/* @ngInject */
export default function($timeout) {
  return {
    restrict: 'A',
    link: (scope, el) =>
      $timeout(() => el.focus(), 200)
  };
}
